import { configureStore } from '@reduxjs/toolkit';
import patientApi from './Components/Patient/patientApi';
import patientReducer from './Components/Patient/patientSlice';
import eyetestApi from './Components/Eyetest/eyetestApi';
import eyetestReducer from './Components/Eyetest/eyeTestSlice';
import ordersReducer from './Components/Orders/ordersSlice';
import emailApi from './Components/Email/emailApi';
import emailReducer from './Components/Email/emailSlice';
import dashboardApi from './Components/Dashboard/dashoardApi';
import profileApi from './Components/Profile/profileApi';
import loginApi from './Components/Login/loginApi';
import ordersApi from './Components/Orders/ordersApi';
import opticianApi from './Components/Optician/opticianApi';
import backOfficeApi from './Components/BackOffice/backOfficeApi';
import posApi from './Components/Pos/posApi';
import opticianReducer from './Components/Optician/opticianSlice';
import posReducer from './Components/Pos/posSlice';
import doctorApi from './Components/Doctor/doctorApi';
import doctorReducer from './Components/Doctor/doctorSlice';
import bulkUploadApi from './Components/BulkUpload/bulkUploadApi';

export const store = configureStore({
    reducer: {
        [patientApi.reducerPath]: patientApi.reducer,
        patient: patientReducer,
        [ordersApi.reducerPath]: ordersApi.reducer,
        orders: ordersReducer,
        [eyetestApi.reducerPath]: eyetestApi.reducer,
        eyetest: eyetestReducer,
        [emailApi.reducerPath]: emailApi.reducer,
        email: emailReducer,
        [dashboardApi.reducerPath]: dashboardApi.reducer,
        [profileApi.reducerPath]: profileApi.reducer,
        [bulkUploadApi.reducerPath]: bulkUploadApi.reducer,
        [loginApi.reducerPath]: loginApi.reducer,
        [posApi.reducerPath]: posApi.reducer,
        pos: posReducer,
        [opticianApi.reducerPath]: opticianApi.reducer,
        optician: opticianReducer,
        [doctorApi.reducerPath]: doctorApi.reducer,
        doctor: doctorReducer,
        [backOfficeApi.reducerPath]: backOfficeApi.reducer,
    },

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(patientApi.middleware)
            .concat(ordersApi.middleware)
            .concat(eyetestApi.middleware)
            .concat(emailApi.middleware)
            .concat(bulkUploadApi.middleware)
            .concat(profileApi.middleware)
            .concat(loginApi.middleware)
            .concat(opticianApi.middleware)
            .concat(doctorApi.middleware)
            .concat(posApi.middleware)
            .concat(backOfficeApi.middleware)
            .concat(dashboardApi.middleware),
});
